// @ts-nocheck
import { z } from 'zod';

const booleanString = z.enum(['true', 'false']).optional().transform(value => value === 'true');
export const publicEnvSchema = z.object({
  VITE_APP_ENV: z.enum(['development', 'staging', 'production']).default('development'),
  VITE_PUBLIC_SITE_URL: z.string().url().optional(),
  VITE_FORMS_ENABLED: booleanString,
  VITE_ANALYTICS_ENABLED: booleanString,
  VITE_ERP_PUBLIC: booleanString,
  VITE_KNOWLEDGE_PUBLIC: booleanString,
  VITE_CONTACTS_PUBLIC: booleanString,
  VITE_MEDIA_RIGHTS_APPROVED: booleanString,
}).strict();

const runtimeEnv = import.meta.env || (typeof process !== 'undefined' ? process.env : {});

export function readPublicEnv(source = runtimeEnv) {
  const allowed = {};
  for (const key of Object.keys(publicEnvSchema.shape)) if (source[key] !== undefined) allowed[key] = source[key];
  return publicEnvSchema.parse(allowed);
}

export const publicEnv = readPublicEnv();
